import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'

interface RotatingTextProps {
  words: string[]
  interval?: number
}

export function RotatingText({ words, interval = 3000 }: RotatingTextProps) {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length)
    }, interval)
    return () => clearInterval(timer)
  }, [interval, words.length])

  return (
    <span className="inline-flex relative h-[1.1em] px-1 overflow-hidden align-bottom min-w-[8em]">
      {/* Width reserved via min-w (em scales with font-size). No ghost text in DOM
          so Google does not read a duplicate word ("fair fair") in the H1. */}
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={words[index]}
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          className="absolute left-1 bg-clip-text font-bold text-transparent bg-gradient-to-r from-[#237CCA] to-[#10b981] whitespace-nowrap"
        >
          {words[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  )
}
